<template>
  <div>
    <div class="footer-box">
      <div class="content-box">
        <div class="info-box">
          <img src="@/assets/big_logo.png" />
          <div class="address">
            地址：河北省邯郸市滏东北大街555号工业设计中心2楼
          </div>
          <div class="phone-number">电话：0310-12345678</div>
        </div>
        <div class="line"></div>
        <div class="content-inner-box">
          <div v-for="(item, index) in content" :key="index">
            <span>{{ item.title }}</span>
            <ul>
              <li
                v-for="(item1, index1) in item.children"
                :key="index1"
                @click="toPage(item1.path)"
              >
                {{ item1.name }}
              </li>
            </ul>
          </div>
          <div class="">
            <span style="margin-bottom: 1.25rem">扫码下载</span>
            <img src="@/assets/footer_code_img.png" />
            <img src="@/assets/footer_code_img.png" />
            <img src="@/assets/footer_code_img.png" style="margin-right: 0" />
          </div>
        </div>
      </div>
      <div class="long-line"></div>
      <div class="web-info">
        <div>
          <span>© Copyright © 2023 邯郸融商至之科技有限公司</span>
          <span>.All rights reserved.</span>
          <!-- <span>冀ICP备2024065205号-1</span> -->
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >冀ICP备2024065205号-1</a
          >
        </div>
        <div>
          <img
            src="../../../assets/icon.png"
            alt=""
            style="margin-right: 5px"
          />
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=13040302001633"
            rel="noreferrer"
            target="_blank"
            >冀公网安备13040302001633</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: [
        {
          title: "解決方案",
          children: [
            {
              name: "企业升级解决方案",
              path: "/intellectual",
            },
            {
              name: "产业研发解决方案",
              path: "/product",
            },
            {
              name: "企业IPO解决方案",
              path: "/corporate",
            },
            {
              name: "商协会解决方案",
              path: "/association",
            },
            {
              name: "企业解决方案",
              path: "/enterprise",
            },
            {
              name: "人才解決方案",
              path: "/talent",
            },
          ],
        },
        {
          title: "产品中心",
          children: [
            {
              name: "产业咨询系统",
              path: "/industrial",
            },
            {
              name: "产业数字金融",
              path: "/digital",
            },
            {
              name: "元宇宙虚拟世界",
              path: "/metaverse",
            },
            {
              name: "人才管理系统",
              path: "/talent-manage",
            },
          ],
        },
        {
          title: "发现更多",
          children: [
            {
              name: "关于我们",
              path: "/about",
            },
            {
              name: "客户案例",
              path: "/case",
            },
            {
              name: "资讯中心",
              path: "/info",
            },
          ],
        },
      ],
    };
  },
  methods: {
    toPage(path) {
      if (this.$route.path !== path) {
        this.$router.push({ path: `${path}` });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.footer-box {
  width: 100%;
  height: 35rem;
  background-color: #25242a;
  .content-box {
    width: 100%;
    height: 26.875rem;
    padding: 4.375rem 13.125rem 0;
    box-sizing: border-box;
    display: flex;
    background-color: #25242a;
    // background-color: #141414;
    .info-box {
      width: 15.75rem;
      height: 14.3125rem;
      margin-right: 5.3125rem;
      img {
        width: 12rem;
        height: 4rem;
        margin-bottom: 3.125rem;
      }
      .address {
        margin-bottom: 2.5rem;
        font-weight: 400;
        font-size: 1rem;
        color: #ffffff;
        line-height: 1.5625rem;
      }
      .phone-number {
        font-weight: 400;
        font-size: 1rem;
        color: #ffffff;
        line-height: 1.5625rem;
      }
    }
    .line {
      width: 0.0625rem;
      height: 300px;
      margin-right: 5.4375rem;
      background-color: #5e5b6e;
    }
    .content-inner-box {
      width: 1076px;
      // margin-right: 9.375rem;
      display: flex;
      justify-content: space-between;
      span {
        display: block;
        height: 2.125rem;
        margin-bottom: 1.875rem;
        font-weight: 500;
        font-size: 1.5rem;
        color: #ffffff;
        line-height: 2.125rem;
      }
      li {
        height: 1.5625rem;
        margin-bottom: 1.125rem;
        font-weight: 400;
        font-size: 0.875rem;
        color: #999999;
        line-height: 1.5625rem;
        list-style: none;
        cursor: pointer;
      }
      img {
        width: 7.1875rem;
        height: 7.1875rem;
        margin-right: 0.9375rem;
      }
    }
  }
  .long-line {
    width: 1500px;
    height: 1px;
    margin-left: 210px;
    margin-bottom: 1px;
    background-color: #5e5b6e;
  }
  .web-info {
    width: 100%;
    height: 8.125rem;
    padding: 2.5rem 31rem;
    font-weight: 400;
    font-size: 0.875rem;
    color: #999999;
    line-height: 1.5625rem;
    text-align: center;
    box-sizing: border-box;
    img {
      width: 14px;
      height: 14px;
    }
    span {
      margin: 0 5px;
    }
    a {
      text-decoration: none;
      color: #3760a9;
    }
  }
}
</style>
